import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { FeedbackPage } from './pages/FeedbackPage';
import { AdminPage } from './pages/AdminPage';
import './i18n';
import './styles/global.css';

// The native apps open the root URL with ?platform=…&app_version=…; a plain <Navigate to="/feedback">
// dropped that query string, so device info never reached the form. Carry it across the redirect.
function RedirectToFeedback() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/feedback', search }} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/admin/feedback" element={<AdminPage />} />
        <Route path="/" element={<RedirectToFeedback />} />
        <Route path="*" element={<RedirectToFeedback />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
